<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col>
        <v-card class="base-centered-card-container" elevation="6">
          <div class="base-card-header-two">
            {{ title }}
          </div>

          <div class="base-card-header">
            {{ title1 }}
          </div>

          <div class="base-card-subheader" :style="fontSizeSubHeader">
            {{ subtitle }}
          </div>
          <slot></slot>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";

@Component({
  name: "BaseCenteredCard",
})
export default class BaseCenteredCard extends Vue {
  @Prop({ default: null }) readonly title!: string;

  @Prop({ default: null }) readonly title1!: string;

  @Prop({ default: null }) readonly subtitle!: string;

  @Prop({ default: "font-size: 16px !important" })
  readonly fontSizeSubHeader!: string;
}
</script>

<style lang="scss">
.base-centered-card-container {
  margin-left: auto;
  margin-right: auto;
  width: 800px;
  padding: 23px 30px;
  box-shadow: 0 0 20px 0 rgba(210, 210, 210, 0.6) !important;
  border-radius: 8px !important;
}
.base-card-header-two {
  font-weight: bold;
  font-size: 28px;
  margin-top: 20px;
}
</style>
